module.exports = __webpack_public_path__ + "static/media/PATS_6-1690w.e0e825f6.png";